import React from "react";

export const STATUS_STYLES = {
  draft: "bg-slate-100 text-slate-700",
  published: "bg-emerald-50 text-emerald-800",
  closed: "bg-amber-50 text-amber-800",
  archived: "bg-slate-50 text-slate-500",
  new: "bg-sky-50 text-sky-800",
  reviewing: "bg-indigo-50 text-indigo-800",
  interview: "bg-violet-50 text-violet-800",
  offer: "bg-teal-50 text-teal-800",
  hired: "bg-emerald-50 text-emerald-800",
  rejected: "bg-rose-50 text-rose-800",
  withdrawn: "bg-slate-100 text-slate-600",
};

export const CANDIDATE_STATUSES = [
  "new",
  "reviewing",
  "interview",
  "offer",
  "hired",
  "rejected",
  "withdrawn",
];

export function candidatePagePath(openingId, candidateId) {
  return `/dashboard/hr/job-openings/${openingId}/candidates/${candidateId}`;
}

export function SectionCard({ title, children, action }) {
  return (
    <section className="rounded-2xl border border-slate-200 bg-white shadow-[0_1px_2px_rgba(0,0,0,.04)]">
      <div className="flex items-center justify-between border-b border-slate-100 px-5 py-4">
        <h2 className="text-sm font-bold uppercase tracking-wide text-slate-500">
          {title}
        </h2>
        {action}
      </div>
      <div className="px-5 py-4">{children}</div>
    </section>
  );
}

export function DetailRow({ label, value }) {
  if (!value && value !== 0) return null;
  return (
    <div className="grid grid-cols-[140px_1fr] gap-3 py-2 text-sm">
      <dt className="font-semibold text-slate-500">{label}</dt>
      <dd className="whitespace-pre-wrap text-slate-800">{value}</dd>
    </div>
  );
}
